import { render } from "./TrainerSessionCard3.vue?vue&type=template&id=5d47dc52&scoped=true"
import script from "./TrainerSessionCard3.vue?vue&type=script&lang=js"
export * from "./TrainerSessionCard3.vue?vue&type=script&lang=js"

import "./TrainerSessionCard3.vue?vue&type=style&index=0&id=5d47dc52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d47dc52"]])

export default __exports__